import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, CheckCircle2, Clock, XCircle } from "lucide-react";
import { API, errMsg } from "../lib/api";

const BADGE = { PENDING: ["text-amber-700 bg-amber-50", Clock, "Proof uploaded, waiting for review"], ACCEPTED: ["text-emerald-700 bg-emerald-50", CheckCircle2, "Proof accepted"],
  REJECTED: ["text-rose-700 bg-rose-50", XCircle, "Proof rejected"] };

export const ProofUpload = ({ token, wid, proof, onDone }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const r = await fetch(`${API}/public/bonus-slips/${token}/proof/${wid}`, { method: "POST", body: fd });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Upload failed");
      toast.success("Signed slip uploaded"); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const [cls, Icon, label] = BADGE[proof?.status] || [];
  return (
    <div className="no-print mt-4 flex flex-wrap items-center gap-3 border-t border-dashed border-slate-300 pt-3 text-sm" data-testid={`proof-${wid}`}>
      {proof ? <span className={`inline-flex items-center gap-1.5 rounded px-2 py-1 ${cls}`} data-testid={`proof-status-${wid}`}><Icon size={14} />{label}{proof.reason && `: ${proof.reason}`}</span>
        : <span className="text-slate-500" data-testid={`proof-status-${wid}`}>After the worker signs, upload a photo or scan of this slip as bonus paid proof.</span>}
      {proof?.status !== "ACCEPTED" && <>
        <input ref={ref} type="file" accept="application/pdf,image/png,image/jpeg" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`proof-input-${wid}`} />
        <button disabled={busy} onClick={() => ref.current?.click()} className="ml-auto inline-flex items-center gap-1.5 rounded-md bg-slate-900 px-3 py-1.5 text-white disabled:opacity-50" data-testid={`proof-upload-${wid}`}>
          <Upload size={14} />{busy ? "Uploading…" : proof ? "Upload again" : "Upload signed slip"}</button></>}
    </div>);
};
